<div class="ui-g-12 service-card mb-3 p-0" #serviceCard>
  <!-- Service header -->
  <div class="ui-g-12 service-head flex-between-start width-100p p-0 pt-2 pb-2">
    <div class="Rectangle-147" [ngClass]="{ 'd-none': isArchived }"
      (click)="handleServiceAction({ name: 'Rearrange Services', value: 'RearrangeServices' })">
      <img src="assets/img/grab-handle-icon.svg" class="grab-handle-icon" />
    </div>

    <div class="d-flex">
      <i class="pointer fas font-21 font-gray-45 ml-4"
        [ngClass]="[!isServiceCollapse ? 'fa-chevron-up' : 'fa-chevron-down']" (click)="serviceAccordion()"></i>
    </div>

    <!-- Left service header -->
    <div class="service-head-left pl-2">
      <div class="flex-start-center text-truncate truncate-input" [ngClass]="{ 'disabled-with-default': isArchived }">
        <div>
          <img [src]="serviceDetails.imageIcon" [ngClass]="serviceDetails.class" [alt]="serviceDetails.altText" />
        </div>

        <app-input id="service-title{{cardIndex}}" type="text" name="serviceTitle" theme="light" placeholder="Add title"
          styleClass="pb-0" styleClassInput="pb-1 font-600 pl-0" [ngClass]="{ 'width-100p': acFocus?.title }"
          [isSetWidthPerChar]="true" [minCharWidth]="7" [showElipses]="true" [isInvalid]="errors?.title" [value]="currentLang === 'fr' ? (service?.titleFR || service?.title) : (service?.title ||
           service?.titleFR)" [maxLength]="100" [fontSize]="14" [hasBorderBottomOnActive]="true"
          [disabled]="isArchived" [autoFocus]="focus.title" (appFocus)="handleFocus('title')"
          (appBlur)="handleBlur('title')" (appChange)="handleChange('title', $event)">
        </app-input>
        <span *ngIf="!acFocus.title && getCategoriesCount()" style="margin-left: -25px;">
          — {{getCategoriesCount()}}
        </span>
        <i *ngIf="motorIncludedServiceTooltip" class="fal fa-info-circle text-dark font-gray-65"
          tooltipStyleClass="ticket-tooltip included-jobs modifier completed" [pTooltip]="motorIncludedServiceTooltip"
          [escape]="false"></i>
        <p class="mb-0 font-11 font-error">{{ errors?.title }}</p>
      </div>
    </div>

    <!-- Right service header -->
    <div class="service-head-right flex-column">
      <div class="flex-end-center height-42 pr-2">
        <!-- Icons before assign tech  -->
        <div *ngIf="!service?.tech?.techId" class="d-flex mt-0 align-self-center">
          <div class="raise-flag-wrapper">
            <img src="assets/img/raise-flag-icons/tech-flag.svg" alt="wrench-tech" tooltipPosition="top"
              [pTooltip]="'No flag is raised by tech'" class="wrench-tech no-cursor" height="20" />
          </div>
        </div>

        <!-- Tech notes-->
        <div class="tech-user-flag raise-flag-wrapper mt-0 align-self-center">
          <app-content-overlay [dropshadow]="true" [defaultState]="service?.openTechNote" [showArrow]="true"
            [closeAfterAction]="true" (appShow)="openTechFlagNotes()" [id]="'tech-flag-'+ service?._id" right="auto"
            [disabled]="!service?.isTechFlag || isArchived && !isFinalizedRo">
            <ng-template appTemplate="item">
              <div class="add-canned-notes" [id]="'tech-flag-'+ service?._id">
                <div class="d-flex" *ngIf="service?.tech?.techId">
                  <img [src]="setTechFlagColor()" alt="wrench-tech" class="wrench-tech"
                    [ngClass]="!service?.techFlag?.flagStatus && 'no-cursor'" />
                </div>
              </div>
            </ng-template>

            <ng-template appTemplate="overlay">
              <div class="filter-overlay w-403">
                <div class="filter-option border-bottom-lightest flex-between-center">
                  <div>
                    <span>
                      Issue Flag
                    </span>
                    <div *ngIf="techFlagStatus"
                      class="badge badge-pill {{ techFlagNoteStatus[techFlagStatus]?.class }}">
                      {{ techFlagNoteStatus[techFlagStatus]?.name }}
                    </div>
                  </div>
                  <div>
                    <img src="assets/img/raise-flag-icons/resolved-flag.svg" class="pointer"
                      [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                      *ngIf="service?.techFlag?.flagStatus !== 'resolved' && service.isTechFlag"
                      (click)="$event.stopPropagation(); handleResolvedFlag('resolved')" />

                    <div class="flex font-primary pointer font-14 font-400"
                      [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                      *ngIf="service?.techFlag?.flagStatus === 'resolved' && service.isTechFlag"
                      (click)="$event.stopPropagation(); handleResolvedFlag('open')">
                      <i class="fal fa-undo"></i>
                      <span> Reopen</span>
                    </div>
                  </div>
                </div>
                <div class="p-10">
                  <!-- tech note  -->
                  <div class="tech-flag-section">
                    <div class="header flex-between-center">
                      <div class="d-flex capitalize">
                        <div class="mr-2">
                          <img src="assets/img/raise-flag-icons/solid-round-tech-flag.svg" />
                        </div>
                        {{service?.techFlag?.techName}}
                      </div>
                      <div class="date">
                        <div class="latest" *ngIf="service?.techFlag?.isTechLatest">
                          Latest update
                        </div>
                        <div *ngIf="service?.techFlag?.isTechLatest">&nbsp;-&nbsp;</div>
                        {{service?.techUpdatedAt}}
                      </div>
                    </div>
                    <div class="updated-note-section mb-2">
                      <div class="note tech-note">
                        {{service?.techFlag?.techNotes}}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isAddUserResponse && service?.techFlag?.flagStatus !== 'resolved'">
                    <div class="img mt-2 font-primary pointer" [ngClass]="{'not-allowed': isFinalizedRo}">
                      <span (click)="$event.stopPropagation(); handleAddServiceNote()"
                        [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top">
                        <i class="fas fa-plus p-1"></i>
                        Add response
                      </span>
                    </div>
                  </div>
                  <!-- office note  -->
                  <div class="user-flag-section" *ngIf="isAddUserResponse">
                    <div class="mt-3" *ngIf="service?.techFlag?.flagStatus && service.isTechFlag">
                      <div class="">
                        <div class="header"
                          [ngClass]="isHideTechTextbox && service?.techFlag?.adminNotes ?'flex-between-center' : 'flex-end-center'">
                          <div class="date" *ngIf="isHideTechTextbox && service?.techFlag?.adminNotes">
                            <div class="latest" *ngIf="service?.techFlag?.isOfficeLatest">
                              Latest update
                            </div>
                            <div *ngIf="service?.techFlag?.isOfficeLatest">&nbsp;-&nbsp;</div>
                            {{ service?.adminUpdatedAt }}
                          </div>
                          <div class="capitalize"
                            *ngIf="service?.techFlag?.flagStatus === 'open' && service.isTechFlag || service?.techFlag?.flagStatus === 'resolved' && service.isTechFlag && service?.techFlag?.adminNotes">
                            {{service?.techFlag?.adminName || userName}}
                            <span>
                              <img src="assets/img/raise-flag-icons/white-headphone.svg" />
                            </span>
                          </div>
                        </div>
                        <div
                          [ngClass]="!isHideTechTextbox && service?.techFlag?.adminNotes && service?.techFlag?.flagStatus === 'open' && service.isTechFlag && 'edit-placeholder'">
                          <app-textarea
                            *ngIf="!isHideTechTextbox && service?.techFlag?.flagStatus === 'open' && service.isTechFlag"
                            type="text" name="serviceTitle" theme="light" placeholder="Type here..."
                            [disabled]="isFinalizedRo" rows="{{service?.techFlag?.adminNotes? 3 : 1}}" styleClass="pb-0"
                            [styleClassInput]="updatePlaceholderColor()" [maxLength]="500"
                            [hasBorderBottomOnActive]="false" [value]="service?.techFlag?.adminNotes" [fontSize]="14"
                            (appChange)="handleFlagChange($event)">
                          </app-textarea>
                          <div class="updated-note-section mb-2"
                            *ngIf="isHideTechTextbox && service?.techFlag?.adminNotes">
                            <div class="note">
                              {{service?.techFlag?.adminNotes}}
                            </div>
                            <div class="img" *ngIf="service?.techFlag?.flagStatus === 'open' && service.isTechFlag"
                              [ngClass]="{'disabled-estimate-field': isFinalizedRo}">
                              <span (click)="$event.stopPropagation(); handleEditNote()"
                                [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top">
                                <i class="fas fa-pencil p-1"></i>
                                Update
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="flex-end-center mb-2"
                          *ngIf="!isHideTechTextbox && service?.techFlag?.flagStatus === 'open' && service.isTechFlag">
                          <button id="btn-cancel" class="btn btn-border pointer btn-submit mr-2 mt-2"
                            [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top"
                            [ngClass]="{'disabled-estimate-field': isFinalizedRo}" [disabled]="isFinalizedRo"
                            (click)="$event.stopPropagation(); handleDiscardTechNote()">
                            Discard
                          </button>
                          <button class="btn btn-primary btn-submit font-12 mt-2"
                            [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                            [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top"
                            (click)="$event.stopPropagation(); handleCreateFlag()" [disabled]="!service?.techFlag?.adminNotes ||
                            service?.techFlag?.defaultNote === service?.techFlag?.adminNotes || isFinalizedRo">
                            <span>
                              {{service?.techFlag?.defaultNote ? 'Update': 'Respond'}}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </ng-template>
          </app-content-overlay>
        </div>

        <div class="office-user-flag">
          <app-content-overlay [dropshadow]="true" [showArrow]="true" [defaultState]="service?.openOfficeNote"
            [disabled]="isArchived && !isFinalizedRo" id="office-flag-{{service?._id}}" [closeAfterAction]="true"
            right="auto" (appShow)="openAdminFlagNotes()">
            <ng-template appTemplate="item">
              <div class="add-canned-notes" id="office-flag-{{service?._id}}">
                <img [src]="setOfficeFlagIcon()" alt="office-flag" height="22" />
              </div>
            </ng-template>

            <ng-template appTemplate="overlay">
              <div class="filter-overlay w-403">
                <div class="filter-option border-bottom-lightest flex-between-center">
                  <div>
                    <span>
                      Issue Flag
                    </span>
                    <div *ngIf="officeFlagStatus"
                      class="badge badge-pill {{ officeFlagNoteStatus[officeFlagStatus]?.class }}">
                      {{ officeFlagNoteStatus[officeFlagStatus]?.name }}
                    </div>
                  </div>
                  <div>
                    <img src="assets/img/raise-flag-icons/resolved-flag.svg" class="pointer"
                      [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                      *ngIf="service?.officeFlag?.flagStatus === 'open' && service.isOfficeFlag"
                      (click)="$event.stopPropagation(); handleResolvedOfficeFlag('resolved')" />

                    <div class="flex font-primary pointer font-14 font-400"
                      [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                      *ngIf="service?.officeFlag?.flagStatus === 'resolved' && service.isOfficeFlag"
                      (click)="$event.stopPropagation(); handleResolvedOfficeFlag('open')">
                      <i class="fal fa-undo"></i>
                      <span> Reopen</span>
                    </div>

                  </div>
                </div>
                <div class="p-10">
                  <div class="tech-flag-section">
                    <div class="header flex-between-center" *ngIf="service?.officeFlag?.techName">
                      <div class="d-flex capitalize">
                        <div class="mr-2">
                          <img src="assets/img/raise-flag-icons/solid-round-tech-flag.svg" />
                        </div>
                        {{service?.officeFlag?.techName}}
                      </div>
                      <div class="date">
                        <div class="latest" *ngIf="service?.officeFlag?.isTechLatest">
                          Latest update</div>
                        <div *ngIf="service?.officeFlag?.isTechLatest">&nbsp;-&nbsp;</div>
                        {{service?.officeTechUpdatedAt}}
                      </div>
                    </div>
                    <div class="updated-note-section mb-2" *ngIf="service?.officeFlag?.techNotes">
                      <div class="note tech-note">
                        {{service?.officeFlag?.techNotes}}
                      </div>
                    </div>
                  </div>

                  <div class="user-flag-section">
                    <div class="mt-3" *ngIf="service?.officeFlag?.flagStatus && service.isOfficeFlag">
                      <div class="">
                        <div class="header"
                          [ngClass]="isHideAdminTextbox && flagNote ?'flex-between-center' : 'flex-end-center'">
                          <div class="date d-flex" *ngIf="isHideAdminTextbox && flagNote">
                            <div class="latest" *ngIf="service?.officeFlag?.isOfficeLatest">
                              Latest update</div>
                            <div *ngIf="service?.officeFlag?.isOfficeLatest">&nbsp;-&nbsp;</div>
                            {{ service?.officeAdminUpdatedAt }}
                          </div>
                          <div class="capitalize">
                            {{userName}}
                            <span>
                              <img src="assets/img/raise-flag-icons/white-headphone.svg" />
                            </span>
                          </div>
                        </div>
                        <div
                          [ngClass]="!isHideAdminTextbox && flagNote && service?.officeFlag?.flagStatus !== 'resolved' && service.isOfficeFlag && 'edit-placeholder'">
                          <app-textarea type="text" name="serviceTitle" theme="light" placeholder="Type here..."
                            rows="{{flagNote? 3 : 1}}" styleClass="pb-0" [disabled]="isArchived"
                            *ngIf="!isHideAdminTextbox && service?.officeFlag?.flagStatus !== 'resolved' && service.isOfficeFlag"
                            [styleClassInput]="updateTechPlaceholderColor()" [maxLength]="500"
                            [hasBorderBottomOnActive]="false" [value]="flagNote" [fontSize]="14"
                            (appChange)="handleOfficeFlagChange($event)">
                          </app-textarea>
                          <div class="updated-note-section mb-2" *ngIf="isHideAdminTextbox && flagNote">
                            <div class="note">
                              {{flagNote}}
                            </div>
                            <div class="img"
                              *ngIf="service?.officeFlag?.flagStatus !== 'resolved' && service.isOfficeFlag">
                              <span (click)="$event.stopPropagation(); handleEditUserNote()"
                                [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top"
                                [ngClass]="{'disabled-estimate-field': isFinalizedRo}">
                                <i class="fas fa-pencil p-1"></i>
                                Update
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="flex-end-center mb-2" *ngIf="!isHideAdminTextbox && service?.officeFlag?.flagStatus !== 'resolved' &&
                         service.isOfficeFlag">
                          <button id="btn-cancel" class="btn btn-border pointer btn-submit mr-2 mt-2"
                            [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top"
                            [ngClass]="{'disabled-estimate-field': isFinalizedRo}" [disabled]="isFinalizedRo"
                            (click)="$event.stopPropagation(); handleDiscardOfficeNote()" *ngIf="flagNote">
                            Discard
                          </button>
                          <button class="btn btn-primary btn-submit font-12 mt-2"
                            [ngClass]="{'disabled-estimate-field': isFinalizedRo}"
                            [pTooltip]="showFinalizedDisableTooltip()" tooltipPosition="top"
                            (click)="$event.stopPropagation(); handleCreateOfficeFlag()"
                            [disabled]="!flagNote || service?.officeFlag?.defaultNote === flagNote || isFinalizedRo">
                            <span>
                              {{service?.officeFlag?.defaultNote ? 'Update': 'Create Flag'}}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </ng-template>
          </app-content-overlay>
        </div>

        <!-- Deferred services pills -->
        <h3 *ngIf="isDeferredServiceEnabled" class="m-0 height-42 flex-center-center mx-2 font-14 width-130px">
          <span *ngIf="service.serviceStatus !== 'deferredLocked'"
            class="badge badge-pill badge-authorized {{ serviceStatusBadge[service.serviceStatus]?.class }}">
            {{ serviceStatusBadge[service.serviceStatus]?.name }}
          </span>

          <span *ngIf="service.serviceStatus === 'deferredLocked'"
            class="badge badge-pill badge-deferred-locked pointer"
            (click)="openRO(service?.deferredFromEstimate?.estimateId)">
            <i class="fal fa-check-circle"></i>
            Deferred to RO#{{ service?.deferredFromEstimate?.estimateCode }}
          </span>
        </h3>

        <!-- Job status -->
        <p class="p-2 m-0 height-42 flex-center-center mr-2 font-14 bborder" [hidden]="!service?.tech?.techId">
          {{ helperService.serviceInspectionStatusMap(service.status) }}
        </p>

        <!-- Multi-technician assignment -->
        <div *ngIf="dataService.isAdminTechControlEnabled" class="multi-tech-assignment flex-start-center"
          [ngClass]="{ 'not-allowed': isArchived }">
          <span *ngIf="!service?.tech?.techId" class="font-600 mr-2">Assign&nbsp;technician</span>

          <div *ngIf="service?.tech?.techId" [id]="'tech-'+ service?.tech?.techId + '-' + service._id"
            (click)="toggleTechCard(service?.tech?.techId, 'tech')"
            class="tech-assign-circle flex-center-center mr-2 primary-tech {{ service?.tech?.workStatus }}"
            [ngClass]="cardId === 'tech'  &&  isTechnicianDetailsVisible ? 'active' : ''" tooltipPosition="top"
            [pTooltip]="service?.tech?.tooltip" [escape]="false">
            <span class="initial font-bold">{{ techInitials[service?.tech?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.tech?.workStatus]"
              [alt]="workStateTitle[service?.tech?.workStatus]" />
          </div>

          <div *ngIf="service?.hTechOne?.techId" [id]="'tech-'+ service?.hTechOne?.techId + '-' + service._id"
            (click)="toggleTechCard(service?.hTechOne?.techId, 'hTechOne')"
            class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechOne?.workStatus }}" tooltipPosition="top"
            [ngClass]="cardId === 'hTechOne'  &&  isTechnicianDetailsVisible  ? 'active' : ''"
            [pTooltip]="service?.hTechOne?.tooltip" [escape]="false">
            <span class="initial font-600">{{ techInitials[service?.hTechOne?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechOne?.workStatus]"
              [alt]="workStateTitle[service?.hTechOne?.workStatus]" />
          </div>

          <div *ngIf="service?.hTechTwo?.techId" [id]="'tech-'+ service?.hTechTwo?.techId + '-' + service._id"
            (click)="toggleTechCard(service?.hTechTwo?.techId , 'hTechTwo')"
            class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechTwo?.workStatus }}" tooltipPosition="top"
            [ngClass]="cardId === 'hTechTwo' &&  isTechnicianDetailsVisible ? 'active' : ''"
            [pTooltip]="service?.hTechTwo?.tooltip" [escape]="false">
            <span class="initial font-600">{{ techInitials[service?.hTechTwo?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechTwo?.workStatus]"
              [alt]="workStateTitle[service?.tech?.workStatus]" />
          </div>

          <i class="fal fa-plus add-tech flex-center-center font-gray p-2" [ngClass]="{ 'not-allowed': isArchived }"
            (click)="handleOpenTechDialog()"
            [hidden]="service?.tech?.techId && service?.hTechOne?.techId && service?.hTechTwo?.techId">
          </i>

          <i class="fal fa-user-hard-hat add-tech flex-center-center font-gray p-2" (click)="handleOpenTechDialog()"
            [ngClass]="{ 'not-allowed': isArchived }"
            *ngIf="service?.tech?.techId && service?.hTechOne?.techId && service?.hTechTwo?.techId">
          </i>
        </div>

        <div *ngIf="!dataService.isAdminTechControlEnabled" class="multi-tech-assignment flex-start-center"
          [ngClass]="{ 'not-allowed': isArchived }" (click)="handleOpenTechDialog()">
          <span *ngIf="!service?.tech?.techId" class="font-600 mr-2">Assign&nbsp;technician</span>

          <div *ngIf="service?.tech?.techId"
            class="tech-assign-circle flex-center-center mr-2 primary-tech {{ service?.tech?.workStatus }}"
            tooltipPosition="top" [pTooltip]="service?.tech?.tooltip" [escape]="false">
            <span class="initial font-bold">{{ techInitials[service?.tech?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.tech?.workStatus]"
              [alt]="workStateTitle[service?.tech?.workStatus]" />
          </div>

          <div *ngIf="service?.hTechOne?.techId"
            class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechOne?.workStatus }}" tooltipPosition="top"
            [pTooltip]="service?.hTechOne?.tooltip" [escape]="false">
            <span class="initial font-600">{{ techInitials[service?.hTechOne?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechOne?.workStatus]"
              [alt]="workStateTitle[service?.hTechOne?.workStatus]" />
          </div>

          <div *ngIf="service?.hTechTwo?.techId"
            class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechTwo?.workStatus }}" tooltipPosition="top"
            [pTooltip]="service?.hTechTwo?.tooltip" [escape]="false">
            <span class="initial font-600">{{ techInitials[service?.hTechTwo?.techId]?.initials }}</span>
            <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechTwo?.workStatus]"
              [alt]="workStateTitle[service?.tech?.workStatus]" />
          </div>

          <i class="fal fa-plus add-tech flex-center-center font-gray p-2" [ngClass]="{ 'not-allowed': isArchived }"
            [hidden]="service?.tech?.techId && service?.hTechOne?.techId && service?.hTechTwo?.techId"></i>
        </div>

        <!-- Tech details card -->
        <div [ngClass]="{ 'd-none': !isTechnicianDetailsVisible, 'd-block': isTechnicianDetailsVisible }">
          <div class="tech-info">
            <span class="tech-card-arrow">
              <span class="dropdown-menu-arrow"></span>
            </span>
            <div class="tech-info-body">
              <!-- header -->
              <div class="header mt-2">
                <div class="font-black order-service-list-item p-2 d-flex justify-content-between">
                  <div class="align-self-center width-65p">
                    <div class="pl-2 font-16 font-600">{{employee?.firstName}} {{employee?.lastName}}</div>
                    <div class="font-gray-55 pl-2 font-14">
                      <span class="capitalize">{{employee?.role}}</span>

                      <span *ngIf="currentService?.service?.[cardId]?.techId">
                        <span class="font-10 capitalize mb-1 ml-1 p-1 br-3 out-of-shop" *ngIf="!employee?.clockedIn">Out
                          of shop</span>
                        <span class="font-10 capitalize mb-1 ml-1 p-1 br-3 idle"
                          *ngIf="employee?.clockedIn && (inProgressService.length === 0) && (currentService?.service?.[cardId]?.workStatus === 'pause' || currentService?.service?.[cardId]?.workStatus === 'completed' || currentService?.service?.[cardId]?.workStatus === 'new') ">Idle</span>
                        <span class="font-10 capitalize mb-1 ml-1 p-1 br-3 working" *ngIf="employee?.clockedIn &&
                          (currentService?.service?.[this.cardId]?.workStatus === 'inprogress' ||
                          inProgressService?.service?.[this.cardId]?.workStatus === 'inprogress' ||
                          currentService?.service?.[this.cardId]?.techId === inProgressService?.service?.['hTechOne'].techId  &&  inProgressService?.service?.['hTechOne']?.workStatus === 'inprogress' ||
                          currentService?.service?.[this.cardId]?.techId === inProgressService?.service?.['hTechTwo'].techId  &&  inProgressService?.service?.['hTechTwo']?.workStatus === 'inprogress' ||
                          currentService?.service?.[this.cardId]?.techId === inProgressService?.service?.['tech'].techId  &&  inProgressService?.service?.['tech']?.workStatus === 'inprogress'
                          )
                          ">
                          Working
                        </span>
                      </span>

                    </div>
                  </div>
                  <span class="">
                    <div class="font-14 font-primary pointer hover-underline"
                      *ngIf="currentService?.service?.[cardId]?.techId"
                      (click)="openTechDetails(currentService?.service?.[cardId]?.techId)">View logs</div>
                  </span>
                </div>
              </div>

              <!-- body -->
              <div class="body">
                <div class="align-self-center width-65p">
                  <div class="pl-3 pr-3 pb-3 pt-2">
                    <div class="font-13 font-600 flex-between-center">
                      <span class="width-200p text-truncate" tooltipPosition="top"
                        [pTooltip]="currentService?.service?.title">
                        {{currentService?.service?.title}}
                      </span>
                      <span
                        class="font-10 capitalize ml-2 p-1 br-3 service-status-box {{currentService?.service?.[cardId]?.workStatus}}">
                        {{workStateTitle[currentService?.service?.[cardId]?.workStatus]}}
                      </span>
                    </div>


                    <!-- PRIMARY tech controls -->
                    <span *ngIf="currentService?.service?.[cardId]?.techId">
                      <!-- Start/Resume button -->
                      <button class="custom-button btn btn-primary btn-block btn-submit font-12 font-bold mt-2"
                        *ngIf="currentService?.service?.[cardId].workStatus === 'new'"
                        [disabled]="isProcessing || isLockedRO"
                        (click)="techServiceAction(currentService?.service, 'inprogress')">
                        <span [ngClass]="{'pr-2': isProcessing}">
                          <i *ngIf="!isProcessing" class="fal fa-play-circle "></i>
                          <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
                          Start
                        </span>
                      </button>

                      <button class="custom-button btn btn-primary btn-block btn-submit font-12 font-bold mt-2"
                        *ngIf="currentService?.service?.[cardId].workStatus === 'pause'"
                        [disabled]="isProcessing || isLockedRO"
                        (click)="techServiceAction(currentService?.service,'inprogress')">
                        <span [ngClass]="{'pr-2': isProcessing}">
                          <i *ngIf="!isProcessing" class="fal fa-play-circle"></i>
                          <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
                          Resume
                        </span>
                      </button>

                      <!-- Restart -->
                      <button class="custom-button btn btn-white btn-block btn-submit font-12  mt-2"
                        *ngIf="currentService?.service?.[cardId].workStatus === 'completed'"
                        [disabled]="isProcessing || isLockedRO"
                        (click)="techServiceAction(currentService?.service,'inprogress')">
                        <span>
                          <i *ngIf="isProcessing" class="fa fa-spinner rotate"></i>
                          <svg *ngIf="!isProcessing" xmlns="http://www.w3.org/2000/svg" width="14" height="15"
                            viewBox="0 0 14 15" fill="none">
                            <path
                              d="M1.7089 9.42692L0.752665 9.96294C1.04841 10.4905 1.42231 10.9687 1.86391 11.3842L2.61507 10.5859C2.25488 10.247 1.94999 9.85701 1.7089 9.42692Z"
                              fill="#6E7777" />
                            <path
                              d="M3.39541 11.1833L2.82089 12.1169C3.33777 12.4349 3.89771 12.6704 4.48517 12.8166L4.74996 11.7529C4.272 11.6339 3.81626 11.4423 3.39541 11.1833Z"
                              fill="#6E7777" />
                            <path
                              d="M6.62072 11.847C6.39491 11.8792 6.16383 11.8956 5.93365 11.8956C5.93351 11.8956 5.93332 11.8956 5.93332 11.8956H5.91951C5.85397 11.8956 5.78766 11.8942 5.72245 11.8916L5.67845 12.987C5.75829 12.9901 5.83939 12.9918 5.91965 12.9918H5.93324C5.93346 12.9918 5.93365 12.9918 5.93384 12.9918C6.21543 12.9918 6.4986 12.9718 6.77545 12.9323L6.62072 11.847Z"
                              fill="#6E7777" />
                            <path
                              d="M8.24452 11.3069C8.02922 11.4247 7.80339 11.5266 7.57326 11.6098L7.94598 12.6407C8.22877 12.5384 8.50623 12.4132 8.77064 12.2686L8.24452 11.3069Z"
                              fill="#6E7777" />
                            <path
                              d="M9.57841 10.231C9.4176 10.4165 9.24112 10.5911 9.05398 10.7501L9.76366 11.5855C9.99305 11.3907 10.2093 11.1766 10.4065 10.9493L9.57841 10.231Z"
                              fill="#6E7777" />
                            <path
                              d="M13.2248 6.56099L11.839 7.94699V7.07227C11.839 5.49114 11.2233 4.0046 10.1052 2.88654C8.98721 1.76851 7.50066 1.15275 5.91951 1.15275C4.33839 1.15275 2.85184 1.76848 1.73379 2.88651C0.615727 4.00454 0 5.49111 0 7.07227C0 7.68061 0.0920391 8.28067 0.273547 8.85576L1.31893 8.52578C1.17113 8.05757 1.09621 7.56853 1.09621 7.07227C1.09621 4.41268 3.25992 2.24896 5.91951 2.24896C8.5791 2.24896 10.7428 4.41268 10.7428 7.07227V7.93802L9.34855 6.54721L8.57437 7.32328L11.2972 10.0394L14 7.33602L13.2248 6.56099Z"
                              fill="#6E7777" />
                          </svg>
                          Restart
                        </span>
                      </button>

                      <!-- Pause/Complete -->
                      <span class="btn-50" *ngIf="currentService?.service?.[cardId].workStatus === 'inprogress'">
                        <button class="custom-button btn btn-white btn-block btn-submit font-12 mt-2"
                          [disabled]="isLoading || isLockedRO"
                          (click)="techServiceAction(currentService?.service,'pause')">
                          <span [ngClass]="{'pr-2': isLoading}">
                            <i *ngIf="!isLoading" class="fal fa-pause-circle"></i>
                            <i *ngIf="isLoading" class="fa fa-spinner rotate"></i>
                            Pause
                          </span>
                        </button>

                        <button class="custom-button btn btn-primary btn-block btn-submit font-12 mt-2"
                          [disabled]="isProcessing || isLockedRO"
                          (click)="techServiceAction(currentService?.service,'completed')">
                          <span [ngClass]="{'pr-2': isProcessing}">
                            <i *ngIf="!isProcessing" class="far fa-check-circle pr-2"></i>
                            <i *ngIf="isProcessing" class="fa fa-spinner rotate"></i>
                            Complete
                          </span>
                        </button>
                      </span>
                    </span>
                    <div class="font-14 mt-2" *ngIf="currentService?.service"><span class="font-gray-35">Elapsed</span>
                      <span [ngClass]="{'font-error': timeAllocated < timeSpent}"> {{timeSpent}}</span>
                    </div>
                    <div class="font-14" *ngIf="currentService?.service"><span class="font-gray-35">Allotted</span>
                      {{timeAllocated}}</div>
                  </div>

                </div>
              </div>

              <!-- footer -->
              <div class="footer">
                <div class="p-3">
                  <!-- {{currentService?.service?.[cardId].workStatus}} -->
                  <span *ngIf="currentService?.service?.[cardId]?.techId">
                    <span *ngIf="currentService?.service?.[cardId].workStatus === 'completed' &&
                      (inProgressService?.service?.['tech'].workStatus !== 'inprogress' &&
                      inProgressService?.service?.['hTechOne'].workStatus !== 'inprogress' &&
                      inProgressService?.service?.['hTechTwo'].workStatus !== 'inprogress' )"><i
                        class="fa fa-info-circle mr-2 icon-completed"></i> <span>Tech has completed this
                        job</span></span>
                    <span *ngIf="currentService?.service?.[cardId].workStatus === 'pause' &&
                     (inProgressService?.service?.['tech'].workStatus !== 'inprogress' &&
                      inProgressService?.service?.['hTechOne'].workStatus !== 'inprogress' &&
                      inProgressService?.service?.['hTechTwo'].workStatus !== 'inprogress' )"><i
                        class="fa fa-info-circle mr-2 icon-inprogress"></i> <span>Tech has paused this
                        service</span></span>
                    <span *ngIf="currentService?.service?.[cardId].workStatus === 'inprogress' "><i
                        class="fa fa-info-circle mr-2 icon-completed"></i> <span>Tech is working on this
                        service</span></span>
                    <span *ngIf="currentService?.service?.[cardId].workStatus === 'new'  &&
                     (inProgressService?.service?.['tech'].workStatus !== 'inprogress' &&
                     inProgressService?.service?.['hTechOne'].workStatus !== 'inprogress' &&
                     inProgressService?.service?.['hTechTwo'].workStatus !== 'inprogress' )"><i
                        class="fa fa-info-circle mr-2 icon-new"></i> <span>Tech has not started this
                        service</span></span>
                    <span *ngIf="(inProgressService?.service?.['tech'].workStatus === 'inprogress' ||
                       inProgressService?.service?.['hTechOne'].workStatus === 'inprogress' ||
                       inProgressService?.service?.['hTechTwo'].workStatus === 'inprogress') &&
                      ( currentService?.service?.[cardId].workStatus === 'pause' ||
                       currentService?.service?.[cardId].workStatus === 'new' ||
                       currentService?.service?.[cardId].workStatus === 'completed')">
                      <i class="fa fa-info-circle mr-2 icon-inprogress"></i>
                      <span>The tech is working on <span class="pointer font-primary"
                          (click)="openService(currentService?.service?.[cardId]?.techId)">RO#
                          {{inProgressService?.code}} - {{inProgressService?.service?.title}}</span>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mitchell1 Repairs -->
        <!-- <div *ngIf="isMitchellIntegrationEnabled && isMitchell1Connected" class="repair-button">
          <button class="flex-start-center btn btn-outline-gray" [disabled]="isMitchell1Loading"
            (click)="handleOpenMitchellInterface()">
            <img src="./assets/img/M1-1.svg" alt="M1-1" />
            Repair
          </button>
        </div> -->

        <div class="flex-center-center height-42 bborder service-ddl"
          [ngClass]="{ 'disabled-dropdown-option': isArchived }">
          <app-dropdown field="name" itemWidth="180px" scrollHeight="150px" hPosition="left"
            styleClassSelectedView="p-0" [disabled]="isArchived" [options]="serviceActions"
            [isDropdownIconVisible]="false" [hasCustomOpenTemplate]="true" (appSelect)="handleServiceAction($event)">
            <ng-template let-item appTemplate="open-dropdown-btn">
              <i class="fas fa-ellipsis-v font-gray-35 p-2"></i>
            </ng-template>
          </app-dropdown>
        </div>

        <!-- Mitchell1 repair and Motor Repair Diagram DD-->
        <div *ngIf="!invoiceType && getRepairGuideOptions()?.length"
          [ngClass]="{ 'disabled-dropdown-option': isArchived }" class="flex-center-center height-42 m-2 bborder">
          <app-dropdown field="name" itemWidth="180px" scrollHeight="150px" hPosition="left"
            styleClassSelectedView="p-0" [showImage]="true" [isDropdownIconVisible]="false" [disabled]="isArchived"
            [hasCustomOpenTemplate]="true" [options]="getRepairGuideOptions()"
            (appSelect)="handleRepairGuideAction($event, service)">
            <ng-template let-item appTemplate="open-dropdown-btn">
              <i class="far fa-file-alt font-16 font-gray"></i>
            </ng-template>
          </app-dropdown>
        </div>

        <!-- Delete -->
        <div *ngIf="!invoiceType" [ngClass]="{'disabled-estimate-field': isArchived}">
          <span class="flex-center-center height-42 pointer ml-2 bborder" (click)="handleConfirmServiceDelete()"
            tabindex="0">
            <i class="card-delete fas fa-trash font-gray"></i>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-0 service-body" (click)="handleBlurAll()" [hidden]="isServiceCollapse">
    <div class="service-notes-inspections d-flex ui-g-12 pb-0">
      <div class="service-notes-container ui-g-6 pl-0" [ngClass]="{
        'ui-g-6': !invoiceType,
        'ui-g-12': invoiceType
      }">
        <app-textarea class="cursor-text" leftIcon="fal fa-sticky-note" type="text" name="serviceNotes"
          [placeholder]="serviceNotesLabel" styleClassLabel="cursor-text" styleClass="service-notes"
          [rightIcon]="isArchived && !isFinalizedRo ? 'fal fa-expand-alt not-active-icon':'fal fa-expand-alt'"
          styleClassInput="" theme="light" [rows]="1" [hasHoverEffect]="true" [disabled]="isArchived" [fontSize]="12"
          [autoGrow]="true" [textAreaId]="service?._id" [maxAutoGrowHeight]="67" [value]="service.notes"
          [maxLength]="2000" [hasBorderBottomOnActive]="true" [fontSize]="14" (appFocus)="handleFocus('notes')"
          (appBlur)="handleBlur('notes')" (appChange)="handleChange('notes', $event)"
          (appRightIconClick)="handleOpenNotesTab('notes')">
        </app-textarea>
      </div>

      <div *ngIf="!invoiceType" class="service-inspections-container ui-g-6">
        <div class="ui-g-12 p-0 service-inspection-section h-100p">
          <!-- Inspection Section -->
          <div class="service-inspection h-100p" [ngClass]="{ 'disabled-inspection': isArchived }">
            <div *ngIf="!serviceInspectionLoading && !service?.inspection?.inspectionId"
              class="flex-start-center h-100p">
              <i class="fal fa-ballot-check font-12 fa-absolute color-a3aaaa"></i>
              <button class="add-inspection btn btn-inspec btn-border color-a3aaaa flex-start-start pointer btn-submit"
                [ngClass]="{ 'disabled-inspection-btn': isArchived }" [disabled]="isArchived"
                (click)="handleOpenInspection()">
                <span class="font-12">Add inspection checklist</span>
              </button>
            </div>

            <div *ngIf="serviceInspectionLoading" class="service-inspection flex-center-center">
              <span class="pr-2">Loading </span>
              <div class="fal fa-spinner rotate"></div>
            </div>

            <div class="h-100p" *ngIf="!serviceInspectionLoading && service?.inspection?.inspectionId"
              [ngClass]="{'disabled-estimate-field': isArchivedRO}">
              <app-service-inspection [isArchived]="isArchived" [inspection]="service?.inspection?.inspectionId"
                (openInspectionDialog)="handleOpenInspectionDialog($event)" [isLockedRO]="isLockedRO"
                [isFinalized]=isFinalizedRo [companyLocalization]="companyLocalization" [currentLang]="currentLang"
                (appDeleteInspection)="handleConfirmInspectionDelete($event)"></app-service-inspection>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="service-table-ins-header flex-between-center ui-g-12">
      <p class="my-0 font-14 font-weight-bold ml-12px">
        <span *ngIf="invoiceType">Adjustment&nbsp;Items&nbsp;</span>
        <span *ngIf="!invoiceType">Service&nbsp;Items&nbsp;</span>
      </p>
      <div class="service-table-ins-line"></div>
    </div>

    <div class="service-table p-0 ui-g-12">
      <div class="service-table-header flex-start-center">
        <div class="table-heading type flex-start-center font-600">Type</div>
        <div class="table-heading description flex-start-center font-600"
          [ngClass]="{ 'quickbook-comp': isQuickbooksCalCompatibiltyOn }">Name</div>
        <div class="table-heading notes flex-start-center font-600"
          [ngClass]="{ 'quickbook-comp': isQuickbooksCalCompatibiltyOn }">Description</div>
        <div class="table-heading cost flex-start-center font-600" [hidden]="!hideCost">Cost</div>
        <div class="table-heading price flex-start-center font-600" [ngClass]="{ 'price-service-writer': !hideCost }">
          Price</div>
        <div class="table-heading quantity flex-start-center font-600">Qty/Hrs</div>
        <div class="table-heading subtotal flex-start-center font-600">Amount</div>
        <div class="table-heading discount flex-start-center font-600">Discount</div>
        <div class="table-heading net-subtotal flex-start-center font-600"
          [ngClass]="{ 'subtotal-service-writer': !hideCost }" *ngIf="isQuickbooksCalCompatibiltyOn">Net&nbsp;Amount
        </div>
        <div class="table-heading taxable flex-start-center font-600"
          [ngClass]="{ 'taxable-service-writer': !hideCost }">Taxable</div>
        <div class="table-heading status flex-start-center font-600">Status</div>
        <div class="table-heading delete"></div>
      </div>
      <!-- [hidden]="item?.isFlatRateSubItem" -->
      <div class="example-list" id="s_{{ service._id }}" cdkDropList [cdkDropListAutoScrollStep]="10"
        [cdkDropListData]="service.items" [cdkDropListConnectedTo]="_serviceIds" (cdkDropListDropped)="drop($event)">
        <div *ngFor="let item of service.items; let rowIndex = index" class="table-body example-box"
          cdkDragBoundary=".estimate-services" cdkDrag>
          <!-- Drag Trigger -->
          <div class="drag-trigger" [hidden]="item.title === null || item.type === ''"
            [ngClass]="{ 'd-none': isArchived || item?.isFlatRateSubItem }" cdkDragHandle></div>

          <div class="drag-trigger-2" [ngClass]="{ 'd-none': isArchived || item?.isFlatRateSubItem }"></div>

          <app-service-item 
            [isPartsTechConnected]="isPartsTechConnected" 
            [isNexpartConnected]="isNexpartConnected"
            [warehouses]="warehouses"
            [invoicedRO]="invoicedRO"
            [partsLookupDropDownList]="partsLookupDropDownList" [customer]="customer" [invoiceType]="invoiceType"
            [customerId]="customerId" [vehicleId]="vehicleId" [isUpdatingServices]="isUpdatingServices"
            [serviceId]="service?._id" [serviceTitle]="service?.title || service?.titleFR" [serviceStatus]="service?.serviceStatus" [serviceInspection]="service?.inspection?.inspectionId"
            [isPartsOrderingDisassociateEnabled]="isPartsOrderingDisassociateEnabled" [subletPricing]="subletPricing"
            [isDiscountItemEnabled]="isDiscountItemEnabled" [isInventoryEnabled]="isInventoryEnabled"
            [isReturnFeatureEnabled]="isReturnFeatureEnabled" [isPartsOrdingCostEditabled]="isPartsOrdingCostEditabled"
            [partOrderingStatus]="partOrderingStatus[item?._id] || partOrderingStatus[item?.orderItemId]"
            [uniqueInternalReferenceCount]="uniqueInternalReferenceCount" [updatedDefaultCount]="item?.defaultCount"
            [isItemOrderQtyChangeFromALEnabled]="isItemOrderQtyChangeFromALEnabled"
            [countOfItemsExistsInFees]="countOfItemsExistsInFees" [itemData]="service.items[rowIndex]?.itemData"
            [estimateId]="estimateId" [itemTypeOptions]="itemTypeOptions"
            [defaultItemTypeOptions]="defaultItemTypeOptions" [customFleetSettings]="customFleetSettings"
            [partPricingRule] = 'partPricingRule'
            [partOverRideToApply] = 'partOverRideToApply' [tirePricingRule] = 'tirePricingRule' [tireOverRideToApply] = 'tireOverRideToApply'
            [adHocMap]="adHocMap" [hasCore]="item?.hasCore" [hasReturn]="item?.hasReturn"
            [pricingList] = 'pricingList'
            [isQuickbooksCalCompatibiltyOn]="isQuickbooksCalCompatibiltyOn" [isOtherTaxable]="isOtherTaxable"
            [isSubletTaxable]="isSubletTaxable" [serviceTech]="service?.tech" [vehicleName]="vehicleName"
            [motorLaborPricing]="motorLaborPricing" [isArchived]="isArchived" [itemSettings]="itemSettings"
            [motorVehicle]="motorVehicle" [estimateCode]="estimateCode" [serviceId]="service?._id" [serviceItem]="item"
            [defaultTax]="defaultTax" [qboRefs]="qboRefs" [remainingAmount]="remainingAmount" [index]="rowIndex"
            [cardIndex]="cardIndex" [isLast]="service.items.length - 1 === rowIndex" [serviceTags]="serviceTags"
            [hideCost]="hideCost" [isBalanceNegative]="isBalanceNegative" [isFinalizedRo]="isFinalizedRo"
            [isOverrideCostWithTechRate]="isOverrideCostWithTechRate" [isArchivedRO]="isArchivedRO"
            (appOnEditing)="onEditingServiceItem($event)" (appEmitCostUpdated)="emitCostUpdated($event)"
            (handleOpenCatalogueDialog)="handleOpenCatalogueDialog($event)"
            (handleOpenInventoryDialog)="handleOpenCatalogueDialog($event)"
            (appGetAndSelectBundleItem)="getAndSelectBundleItem($event)"
            (addAssociatedItems)="fetchAndSelectAttachedItems($event)" (itemDelete)="itemDelete($event)"
            (calculateTotal)="calculateTotal()" (addServiceItem)="addRow($event)"
            (insertServiceItem)="insertServiceItem($event)" (appTagCreated)="handleTagCreate($event)"
            (updateServiceItem)="updateService($event)" (appOpenItemModal)="handleOpenItemModal($event)"
            (generateActivity)="_generateActivity($event)" (updateTags)="_updateTags($event)"
            (appOpenReturnDialog)="handlePartAndCoreReturnDialog($event)"
            (appSetReturnCoreTags)="setReturnCoreTags($event)" (refetchPartsOrderingCart)="refetchPartsOrderingCart()"
            (appHandleOnlinOrderAction)="handleOnlineOrderingAction($event)"
            (appOnFETFeeUpdate)="handleFETFeeUpdate(item, $event?.lineItem)"
            (appOpenAssignSaleCodeModal)="openAssignSaleCodeModal($event)"
            (removedPartsLookupAndReplace)="removedPartsLookupAndReplaceAction($event)" [currentLang]="currentLang"
            [companyLocalization]="companyLocalization" (appOpenVehicleAction)="appOpenVehicleAction($event)"
            (appRefreshTsInspection)="handleTsInspecionData($event)">
          </app-service-item>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-0 service-footer" [hidden]="isServiceCollapse">
    <div class="footer-control width-100p flex-start-center">
      <div class="d-flex align-items-end summary-gp-values">
        <div *ngIf="!isDeferredServiceEnabled; else recommendedSwitch" class="flex-between-center footer-include-invoice" [ngClass]="{ 'width-50': !hideCost }">
          <label class="flex-start-center m-0">
            <span class="pr-2 pointer">Include in Estimate & Invoice</span>
            <app-checkbox inputId="cb-service-include{{ cardIndex }}" label="" [disabled]="isArchived"
              [isChecked]="service.includeInInvoice" (appChange)="includeInvoiceChange($event)">
            </app-checkbox>
          </label>
        </div>
        <ng-template #recommendedSwitch>
          <div [ngClass]="{ 'ml-3': !isDvi2Enabled }">
            <app-switch-pill [hidden]="isDvi2Enabled" label="Recommended" position="end" [fontSize]="12"
              [isActive]="service?.isRecommended" [disabled]="isArchived" [ngClass]="{ 'disabled-inspection': isArchived }"
              (appChange)="handleRecommentedServiceUpdate($event)">
            </app-switch-pill>
          </div>
        </ng-template>

      <div *ngIf="!isStickyGrossProfitValuesEnabled && !isLocalStickyGrossProfitValues && hideCost" (click)="toggleCollapseState()">
        <div class="icon bg-white p-2 rounded-circle cursor-pointer" pTooltip="Click to see gross profit details for this service">
          <i class="fal fa-money-check-alt font-green font-16"></i>
        </div>
      </div>


        <div class="ml-3 footer-gross-total flex-between-center" *ngIf="hideCost && (isStickyGrossProfitValuesEnabled || isLocalStickyGrossProfitValues)">
          <p class="amount-discount-price flex-column m-0">
            <!-- Gross Profit = Service Net Total - Total Cost -->
            {{ grossProfitValue | currency : usd }}
            <span class="amount-discount-text m-0">Gross profit ($)</span>
          </p>
        </div>
      
        <div class="footer-gross-total flex-between-center" *ngIf="hideCost && (isStickyGrossProfitValuesEnabled || isLocalStickyGrossProfitValues)">
          <p class="amount-discount-price flex-column m-0">
            <!-- Gross Profit Percentage = ((Service Net Total - Service Total Cost) / Service Net Total) * 100 -->
            {{ grossProfitPercentage | percent : '1.2-2' }}
            <span class="amount-discount-text m-0">Gross profit (%)</span>
          </p>
        </div>
      
        <div class="footer-gross-total flex-between-center" *ngIf="hideCost && (isStickyGrossProfitValuesEnabled || isLocalStickyGrossProfitValues)">
          <p class="amount-discount-price flex-column m-0">
            <span *ngIf="grossProfitDollarPerHour !== '-'">
              <!-- Gross Profit Dollar Per Hour = (Service Net Total - Service Total Cost) / Total Service Labor Hours -->
              {{ grossProfitDollarPerHour | currency:'USD' }}
            </span>
            <span *ngIf="grossProfitDollarPerHour === '-'">
              -
            </span>
            <span class="amount-discount-text m-0">Gross profit ($/hr)</span>
          </p>
        </div>
      
        <div (click)="toggleCollapseState()" *ngIf="!isStickyGrossProfitValuesEnabled && isLocalStickyGrossProfitValues && hideCost">
          <div class="icon bg-white p-2 rounded-circle cursor-pointer"
            pTooltip="Click to hide gross profit details for this service">
            <i class="fal fa-eye-slash font-green font-16"></i>
          </div>
        </div>
      </div>

      <div class="d-flex summary-total-values align-items-center">
      <div class="footer-total flex-between-center">
        <p class="amount-discount-price flex-column m-0">
          {{ service.serviceTotal.total | currency : usd }}
          <span class="amount-discount-text m-0">Service total</span>
        </p>
      </div>

      <div class="footer-discount flex-between-center">
        <p class="amount-discount-price flex-column m-0">
          <span class="flex-start-center">
            <span *ngIf="roundOffTax">
              {{ service.serviceTotal.serviceDiscountAmt | currency : usd }}
            </span>

            <span *ngIf="!roundOffTax">
              {{ (service.serviceTotal.serviceLevelDiscount || 0) + (service.serviceTotal.itemLevelDiscount || 0) |
              currency : usd }}
            </span>
            &nbsp;

            <span> ({{ service.serviceTotal.itemLevelDiscount || 0 | currency : usd }} + {{
              service.serviceTotal.serviceLevelDiscount || 0 | currency : usd }}) </span>
          </span>

          <span class="amount-discount-text m-0">Discount</span>
        </p>
      </div>

      <div class="footer-total flex-between-center">
        <p class="amount-discount-price flex-column m-0">
          {{ serviceNetTotal | currency : usd }}
          <span class="amount-discount-text m-0">Service net total</span>
        </p>
      </div>
    </div>

    </div>
  </div>
</div>